import React from 'react';
import { Button } from './ui/button';

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    try {
      console.error('[CHANTIX PageError]', {
        page: window.location.pathname,
        message: error?.message,
        stack: error?.stack,
        componentStack: errorInfo?.componentStack,
      });
    } catch (_e) { void _e; }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || 'Erreur inconnue';
      const errorStack = this.state.error?.stack || '';
      const shortStack = errorStack.split('\n').slice(0, 4).join('\n');

      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-4" data-testid="page-error">
          <div className="text-center max-w-sm w-full">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Erreur sur cette page</h3>
            <p className="text-sm text-gray-600 mb-4">
              Un problème est survenu. Essayez de recharger cette section.
            </p>
            <div className="flex gap-2 justify-center mb-4">
              <Button onClick={this.handleRetry} className="bg-[#0055FF] hover:bg-blue-700">
                Réessayer
              </Button>
              <Button variant="outline" onClick={() => { window.location.href = '/dashboard'; }}>
                Accueil
              </Button>
            </div>
            <details className="text-left mt-4 p-3 bg-gray-100 rounded-lg">
              <summary className="text-xs font-medium text-gray-700 cursor-pointer">
                Details techniques (pour le support)
              </summary>
              <div className="mt-2 text-xs text-red-700 font-mono break-all whitespace-pre-wrap overflow-auto max-h-40">
                <p className="font-bold">{errorMsg}</p>
                <p className="mt-1 text-gray-600">{shortStack}</p>
              </div>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PageErrorBoundary;
